import { atom } from "recoil";

export const inquiryBackArrowState = atom({
  key: "inquiryBackArrowState",
  default: false,
});
